import * as yup from 'yup';
import { useFormHandler } from './useFormHandler';

export type AddGiftToExamConfigFormValues = {
  ranking: string;
  name: string;
};

const addGiftToExamConfigValidationSchema = yup.object().shape({
  ranking: yup.string().required('Le rang est obligatoire'),
  name: yup.string().required('Le nom du cadeau est obligatoire'),
});

export const useAddGiftToExamConfigForm = () => {
  const { register, handleSubmit, errors, setValue, reset, getValues, watch } =
    useFormHandler<AddGiftToExamConfigFormValues>(
      addGiftToExamConfigValidationSchema,
    );

  return {
    register,
    handleSubmit,
    errors,
    setValue,
    reset,
    getValues,
    watch,
  };
};
